// extracted by mini-css-extract-plugin
export default {"main":"style_main__ZTXtx","examBlock":"style_examBlock__z1+L1"};